import { FC, PropsWithChildren, ReactNode } from 'react';

const Show: FC<
  PropsWithChildren<{
    when: boolean;
    fallback?: ReactNode;
  }>
> = ({ children, when, fallback }) => {
  if (!when) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default Show;
